import React, { FC } from 'react';
import classNames from 'classnames';

import css from './style.module.scss';

interface IProps {
  text?: string;
  indents?: '24-0';
  className?: string;
}

const Divider: FC<IProps> = ({ text, indents, className }) => (
  <div
    className={classNames(
      css.divider,
      {
        [css[`divider_indents_${indents}`]]: indents,
      },
      className,
    )}
  >
    {text && <div className={css.divider__text}>{text}</div>}
  </div>
);

export default Divider;
